import api from '@/api';

export default {
  namespaced: true,

  actions: {
    async DeleteReport(_, report) {
      await api.report.deleteReport({
        projectId: report.projectId,
        reportId: report.id,
      });
    },
  },
};
